<template>
  <b-modal
    id="modal-refund-filter"
    ok-title="Submit"
    cancel-variant="outline-secondary"
    title="過瀘"
    title-class="font-weight-bolder"
    body-class="common_modal modal_visible"
    hide-header
    hide-footer
    no-close-on-backdrop
    size="lg"
    centered
    hide-header-close
  >
    <feather-icon
      @click="hide"
      style="position: absolute; right: 20px; top: -40px"
      size="18"
      icon="XIcon"
    />
    <b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
      <b-form class="mt-1" @submit.prevent="onSubmit">
        <b-row>
          <b-col cols="12">
            <b-form-group
              label="收據："
              label-for="filter_receipt_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_receipt_id"
                v-model="update.filter_receipt_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="receiptOptions"
                label="receipt_number"
                :reduce="(option) => option.id"
                placeholder="選擇收據"
                :filter="receiptSearch"
              >
              </v-select>
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group
              label="客戶："
              label-for="filter_customer_id"
              label-cols-md="3"
              v-if="ability.can('admin', 'refunds')"
            >
              <v-select
                id="filter_customer_id"
                v-model="update.filter_customer_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="customerOptions"
                label="name_cn"
                :reduce="(option) => option.id"
                placeholder="選擇客戶"
                :filter="customerSearch"
              >
                <template #option="{ name_cn, user_number }">
                  [{{ user_number }}] {{ name_cn }}
                </template>
                <template #selected-option="{ name_cn, user_number }">
                  [{{ user_number }}] {{ name_cn }}
                </template>
              </v-select>
            </b-form-group>
          </b-col>
          <!-- <b-col cols="12">
            <b-form-group
              label="項目："
              label-for="filter_project_id"
              label-cols-md="3"
            >
              <v-select
                id="filter_project_id"
                v-model="update.filter_project_id"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="projectOptions"
                label="項目"
                :reduce="(option) => option.id"
                placeholder="選擇項目"
                :filter="projectSearch"
              >
                <template #option="{ project_name, project_number }">
                  [{{ project_number }}] {{ project_name }}
                </template>
                <template #selected-option="{ project_name, project_number }">
                  [{{ project_number }}] {{ project_name }}
                </template>
              </v-select>
            </b-form-group>
          </b-col> -->
        </b-row>
        <div class="d-flex mt-2 justify-content-end">
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            variant="outline-secondary"
            @click="update = {}"
            class="mr-1"
          >
            重置
          </b-button>
          <b-button
            v-ripple.400="'rgba(186, 191, 199, 0.15)'"
            type="button"
            variant="outline-danger"
            class="mr-1"
            @click="hide"
          >
            取消
          </b-button>
          <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            type="submit"
          >
            <feather-icon size="16" class="mr-1" icon="CheckCircleIcon" />
            提交
          </b-button>
        </div>
      </b-form>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BOverlay,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BCard,
  BCardBody,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import ability from "@/libs/acl/ability";

export default {
  components: {
    BButton,
    BModal,
    VBModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCardBody,
    BCard,
    vSelect,
    flatPickr,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-refund-filter");
    },
    onSubmit() {
      this.$emit("update:filter_receipt_id", this.update.filter_receipt_id);
      this.$emit("update:filter_customer_id", this.update.filter_customer_id);
      this.$emit("update:filter_project_id", this.update.filter_project_id);
      this.hide();
    },
    receiptSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return item.receipt_number.toLowerCase().includes(search.toLowerCase());
      });
      return returnOptions;
    },  
    customerSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.name_cn.toLowerCase().includes(search.toLowerCase()) ||
          item.user_number.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
    projectSearch(options, search) {
      var returnOptions = options.filter((item) => {
        return (
          item.project_name.toLowerCase().includes(search.toLowerCase()) ||
          item.project_number.toLowerCase().includes(search.toLowerCase())
        );
      });
      return returnOptions;
    },
  },
  props: {
    receiptOptions: {
      type: Array,
      required: true,
    },
    customerOptions: {
      type: Array,
      required: true,
    },
    projectOptions: {
      type: Array,
      required: true,
    },
    filter_receipt_id: {},
    filter_customer_id: {},
    filter_project_id: {},
  },
  data() {
    return {
      loading: false,
      ability,
      update: {
        filter_receipt_id: null,
        filter_customer_id: null,
        filter_project_id: null,
      },
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
